import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { DashboardLayout } from '@/components/layouts/DashboardLayout';
import { CheckCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function SuccessPage() {
  const navigate = useNavigate();
  const { refreshUserData } = useAuth();

  useEffect(() => {
    refreshUserData();
  }, [refreshUserData]);

  return (
    <DashboardLayout>
      <div className="flex flex-col items-center justify-center py-20 text-center px-4">
        <CheckCircle className="h-16 w-16 text-green-500 mb-4" />
        <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-2">
          Pagamento confirmado!
        </h2>
        <p className="text-gray-600 dark:text-gray-400 mb-8">
          Seus creditos foram adicionados a sua conta.
        </p>
        <Button
          className="bg-green-600 hover:bg-green-700 text-white font-semibold px-8 py-3 text-base"
          onClick={() => navigate('/new')}
        >
          Gerar minhas fotos
        </Button>
      </div>
    </DashboardLayout>
  );
}
